import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { ProgressCircle } from "./ProgressCircle";

const useStyles = makeStyles(
  () => ({
    container: {
      display: "inline-flex",
      position: "relative",
      alignItems: "center",
      justifyContent: "center",
      margin: 10
    },
    labelBox: {
      display: "flex",
      position: "absolute",
      alignItems: "center",
      justifyContent: "center",
      top: 0,
      right: 0,
      bottom: 1,
      left: 0
    }
  }),
  { name: "StepperProgress" }
);

export function StepperProgress(props) {
  const { label = "5/10", progress = 50 } = props;
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <ProgressCircle value={progress} />
      <Box className={classes.labelBox}>
        <Typography variant={"body2"} align={"center"}>
          {label}
        </Typography>
      </Box>
    </div>
  );
}
